module.exports = __webpack_public_path__ + "img/bag-plus.47241153.svg";